// apps/website/src/components/common/Layout/WebLayout.tsx
//
// Reproduces the web-mode branch of ui/revamp:src/components/common/Layout/
// AppLayout.tsx, which used to wrap the marketing pages. The split dropped
// that shared layout from the website, taking the header and the background
// bars with it.
//
// This is the same DOM the old AppLayout emitted when `isAppMode` was false:
//
//   <div class="orra-app-shell mode-web">
//     <BackgroundBars count={9} />
//     <header class="web-header"><TopNav /></header>
//     <div class="app-main-container">
//       <main class="main-viewport">
//         <div class="page-content-wrapper">{children}</div>
//
// The app-only branches (Sidebar, BottomNav, ChurchModal) are intentionally
// absent — the marketing site has no authenticated shell.
import React, { ReactNode } from "react";
import { BackgroundBars } from "../Visuals/BackgroundBars";
import { TopNav } from "./TopNav";
import "../../../styles/components/layout.css";

interface WebLayoutProps {
  children: ReactNode;
}

export const WebLayout: React.FC<WebLayoutProps> = ({ children }) => {
  return (
    <div className="orra-app-shell mode-web">
      <BackgroundBars count={9} />

      <header className="web-header">
        <TopNav />
      </header>

      <div className="app-main-container">
        <main className="main-viewport">
          <div className="page-content-wrapper">{children}</div>
        </main>
      </div>
    </div>
  );
};
